import { RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import { coreStore } from "./store";
import { router } from "./routes";
import { Toaster } from "react-hot-toast";

const App = () => {
  return (
    <Provider store={coreStore}>
      <Toaster position="top-right" />
      <RouterProvider router={router} />
    </Provider>
  );
};

export default App;
